<!-- eslint-disable -->
<template lang="pug">
    table.matrix-table
        tr.matrix-table__row(v-for='(row, rowIndex) in matrixTable')
            td.matrix-table__cell(v-for='(item, itemIndex) in row')
                .matrix-table__item
                    drag.matrix-container__drag(
                        v-if="linksType === 'image' && (item.type !== 'dropZone' || item.type === 'correct-link')"
                        :draggable="gameStarted && item.type !== 'correct-link'"
                        :transfer-data="{ item: item, index: itemIndex, rowIndex: rowIndex, from: 'matrix' }"
                        @dragstart="$emit('dragStarted')"
                        @dragend="$emit('dragEnded')"
                    )
                        img.matrix-link(
                            :class="{'matrix-link_correct': item.type === 'correct-link'}"
                            :src='item.value | apiFile'
                            :data-index='itemIndex'
                            :draggable="gameStarted && item.type !== 'correct-link'"
                        )
                    drop.drop-zone(v-if="item.type === 'dropZone'" @drop='dropItemInMatrix(item, rowIndex, $event)')
                        .drop-zone__shake-zone
                    .matrix-link__text-container(
                        v-if="(linksType === 'word' || linksType === 'phrase') && (item.type !== 'textInput' || item.type === 'correct-link')"
                        :class="{'matrix-link_correct': item.type === 'correct-link', 'matrix-link_tipped': item.helpMarker}"
                    )
                        .matrix-link__text-container__value(:class="currentClassForTextInCell")
                            | {{ item.value }}
                    .matrix-link__input-container.matrix__input-container_white(v-if="item.type === 'textInput'")
                        cs-input.matrix-link__text-input(
                            ref='input'
                            @focus='focusInput'
                            @keyup.native.enter='focusNextElement((rowIndex * tableSize.amountOfColumns) + itemIndex + 1)'
                            v-model='item.value'
                            :disabled="item.type === 'correct-link'"
                            :placeholder="$i18n.t('trainer.trainer_gamePlayBox_answer')"
                        )

</template>

<script>
/*eslint-disable*/
import { Drag, Drop } from 'vue-drag-drop';
const DEFAULT_VOLUME = 0.6;

export default {
    props: {
        matrixTable: {
            type: Array,
            default: () => {
                return [];
            }
        },
        gameStarted: Boolean,
        linkDropped: Boolean,
        linksType: String,
        tableSize: Object
    },
    data () {
        return {
            soundInstance: null,
            isInputFocused: false,
        }
    },
    mounted () {
        window.addEventListener('resize', this.calculateSizeForMatrixTable);
        this.calculateSizeForMatrixTable();
    },
    watch: {
        gameStarted(value) {
            value && this.$nextTick(this.calculateSizeForMatrixTable);
        },
        linkDropped(value) {
            if (value) {
                this.$nextTick(() => {
                    this.calculateSizeForMatrixTable();
                    this.$emit('linkResized')
                });
            }
        },
        '$root.sidebar' (val) {
            setTimeout(() => this.calculateSizeForMatrixTable(), 200);
        }
    },
    updated () {
        this.isInputFocused = this.helperModeOn === true ? false : this.isInputFocused;
        if (!this.isInputFocused && this.$refs.input && this.$refs.input[0]) {
            this.$refs.input[0].$el.blur();
            this.focusNextElement();
        }
        (this.tableSize.amountOfRows === 10 || this.tableSize.amountOfRows === 6) && this.calculateSizeForMatrixTable();
    },
    methods: {
        calculateItemSizeAccordingToWindow(windowWidth) {
            if (windowWidth < 990 && this.tableSize.amountOfColumns < 5 && this.tableSize.amountOfRows >= 5) {
                return 50;
            }
            if (windowWidth < 990 && this.tableSize.amountOfColumns < 5 && this.tableSize.amountOfRows < 5) {
                return 55;
            }
            if (windowWidth < 990 && this.tableSize.amountOfColumns >= 5) {
                return 45;
            }
            if (windowWidth <= 1200 && this.tableSize.amountOfColumns >= 5) {
                return 50;
            }
            if (windowWidth <= 1200 && this.tableSize.amountOfColumns < 5 && this.tableSize.amountOfRows >= 5) {
                return 55;
            }
            if (windowWidth <= 1200 && this.tableSize.amountOfColumns < 5 && this.tableSize.amountOfRows < 5) {
                return 70;
            }
            if (windowWidth <= 1440 && this.tableSize.amountOfColumns >= 5) {
                return 60;
            }
            if (windowWidth <= 1440 && this.tableSize.amountOfColumns < 5 && this.tableSize.amountOfRows < 5) {
                return 80;
            }
            if (windowWidth <= 1440 && this.tableSize.amountOfColumns < 5 && this.tableSize.amountOfRows >= 5) {
                return 65;
            }
            if (windowWidth > 1440 && this.tableSize.amountOfColumns >= 5) {
                return 60;
            }
            if (windowWidth > 1440 && this.tableSize.amountOfColumns >= 5 && this.tableSize.amountOfRows >= 5) {
                return 60;
            }
            if (windowWidth > 1440 && this.tableSize.amountOfColumns < 5 && this.tableSize.amountOfRows < 5) {
                return 90;
            }
            if (windowWidth > 1440 && this.tableSize.amountOfColumns < 5 && this.tableSize.amountOfRows >= 5) {
                return 70;
            }
        },
        calculateSizeForMatrixTable () {
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            let matrixTable = document.querySelector('.matrix-table');
            const containerWidth = windowWidth < 1200
                ? matrixTable.parentElement.parentElement.clientWidth
                : matrixTable.parentElement.parentElement.clientWidth - 150;
            const maxTableWidth = Math.min(matrixTable.clientWidth, containerWidth);
            let maxTableHeight = this.tableSize.amountOfRows > 6
                ? Math.min(windowHeight - 380, matrixTable.clientHeight)
                : Math.min(windowHeight - 450, matrixTable.clientHeight)
            if (windowWidth > 1439 && this.tableSize.amountOfRows === 10 && !this.gameStarted) {
                maxTableHeight += +100;
            } else if (windowWidth < 768 && this.linksType != 'image') {
                let FIX_SIZE = {
                    '33': 0, '34': 2, '35': 1, '43': 15, '44': 15, '45': 15, '53': 22, '54': 25, '55': 30
                }
                maxTableHeight += FIX_SIZE[this.tableSize.amountOfRows+""+this.tableSize.amountOfColumns];
            } else if (windowWidth < 1200 && this.linksType != 'image') {
                let FIX_SIZE = {
                    '33': 0, '34': 0, '35': 0, '43': 0, '44': 0, '45': 0, '53': 30, '54': 40, '55': 50
                }
                maxTableHeight += FIX_SIZE[this.tableSize.amountOfRows+""+this.tableSize.amountOfColumns];
            } else if (windowWidth < 1440 && this.linksType != 'image') {
                let FIX_SIZE = {
                    '33': -60, '34': -50, '35': -40, '43': 0, '44': 0, '45': 0, '53': 0, '54': 0, '55': 0
                }
                maxTableHeight += FIX_SIZE[this.tableSize.amountOfRows+""+this.tableSize.amountOfColumns];
            }

            let items = Array.from(document.querySelectorAll('.matrix-table__cell'));
            let links = Array.from(document.querySelectorAll('.link'));
            let itemSize = Math.min(maxTableWidth / this.tableSize.amountOfColumns, maxTableHeight / this.tableSize.amountOfRows);
            itemSize = this.calculateItemSizeAccordingToWindow(windowWidth);

            if (!this.gameStarted && this.tableSize.amountOfRows < 7 && windowWidth > windowHeight) {
                matrixTable.style['width'] = itemSize * 1.2 * this.tableSize.amountOfColumns + 'px';
                matrixTable.style['height'] = itemSize * 1.2 * this.tableSize.amountOfRows + 'px';
            } else if (!this.gameStarted && this.tableSize.amountOfRows < 10 && windowWidth > windowHeight) {
                matrixTable.style['width'] = itemSize * 1.1 * this.tableSize.amountOfColumns + 'px';
                matrixTable.style['height'] = itemSize * 1.1 * this.tableSize.amountOfRows + 'px';
            } else {
                let multiplier = (this.tableSize.amountOfRows < 7 && windowWidth > windowHeight) ? 1.2 : 1.1;
                matrixTable.style['width'] = multiplier * itemSize * this.tableSize.amountOfColumns + 'px';
                matrixTable.style['height'] = multiplier * itemSize * this.tableSize.amountOfRows + 'px';
            }
            if(this.linksType != 'image'){
                if (windowWidth < 768) {
                    matrixTable.style['width'] = itemSize * 1.5 * this.tableSize.amountOfColumns + 'px';
                    matrixTable.style['height'] = itemSize * 1.5 * this.tableSize.amountOfRows + 'px';
                } else if (windowWidth < 992) {
                    matrixTable.style['width'] = itemSize * 2 * this.tableSize.amountOfColumns + 'px';
                    matrixTable.style['height'] = itemSize * 2 * this.tableSize.amountOfRows + 'px';
                } else if(windowWidth < 1200) {
                    matrixTable.style['width'] = itemSize * 2 * this.tableSize.amountOfColumns + 'px';
                    matrixTable.style['height'] = itemSize * 2 * this.tableSize.amountOfRows + 'px';
                } else if(windowWidth < 1440) {
                    matrixTable.style['width'] = itemSize * 2 * this.tableSize.amountOfColumns + 'px';
                    matrixTable.style['height'] = itemSize * 2 * this.tableSize.amountOfRows + 'px';
                } else if(windowWidth >= 1440) {
                    let size = itemSize <= 60 ? 75 : itemSize
                    matrixTable.style['width'] = size * 1.5 * this.tableSize.amountOfColumns + 'px';
                    matrixTable.style['height'] = size * 1.5 * this.tableSize.amountOfRows + 'px';
                }
            }
            let maxLengthWord = 0;
            items.forEach(item => {
                let lineItem = item.outerText?.split(' ') || "";
                for (let line of lineItem) {
                    maxLengthWord = maxLengthWord > line.length ? maxLengthWord : line.length;
                }
                item.style['height'] = 100 / this.tableSize.amountOfRows + '%';
                item.style['width'] = 100 / this.tableSize.amountOfColumns + '%';
            });
            let multiplier = this.currentClassForTextInCell === 'matrix-link__text-container__value_phrase-big' ? 14 : 12;
            if(maxLengthWord * multiplier > document.getElementsByClassName('matrix-link__text-container__value')[0]?.clientWidth){
                items.forEach(item => {
                    if(this.currentClassForTextInCell ==='matrix-link__text-container__value_phrase-big') {
                        item.querySelectorAll('.matrix-link__text-container__value_phrase-big')[0].style['font-size'] = "0.9rem";
                    } else {
                        item.querySelectorAll('.matrix-link__text-container__value_phrase-small')[0].style['font-size'] = "0.8rem";
                    }
                });
            }
            itemSize = Math.max(items[0].clientWidth, 90);
            links.forEach(item => {
                item.style['height'] = 0.75 * itemSize + 'px'
                item.style['width'] = 0.75 * itemSize + 'px'
                if (windowWidth < 1200) {
                    item.style['height'] = 0.75 * itemSize + 'px'
                    item.style['width'] = 0.75 * itemSize + 'px'
                }
                if (windowWidth < 992) {
                    item.style['height'] = 0.65 * itemSize + 'px'
                    item.style['width'] = 0.65 * itemSize + 'px'
                }
            });
        },
        dropItemInMatrix (link, rowIndex, data) {
            if (data && (data.from === 'answers-box' || data.from === 'matrix')) {
                this.soundInstance = this.$createjs.Sound.play("matrixDrop");
                this.soundInstance.volume = DEFAULT_VOLUME;
                if (data.from === 'answers-box') {
                    this.$set(this.matrixTable[rowIndex], this.matrixTable[rowIndex].indexOf(link), _.cloneDeep(data.item));
                    this.$emit('dropItemInMatrix', data.index);
                } else {
                    this.$set(this.matrixTable[rowIndex], this.matrixTable[rowIndex].indexOf(link), _.cloneDeep(data.item));
                    this.$set(this.matrixTable[data.rowIndex], this.matrixTable[data.rowIndex].indexOf(data.item), {type: 'dropZone'});
                }
            }
        },
        focusInput (event) {
            this.isInputFocused = this.$refs.input.some(element => _.isEqual(element.$el, event.target));
        },
        focusNextElement(index = 0) {
            let uncompletedItems = _.flatten(this.matrixTable).filter(item => item.type === "textInput");
            let completedItems = _.flatten(this.matrixTable).filter((item, itemIndex) => item.type !== "textInput" && itemIndex < index);
            index = index - completedItems.length;
            index = index >= uncompletedItems.length ? index % uncompletedItems.length : index;
            let isMatrixCompleted = !_.flatten(this.matrixTable).some(item => item.value === '');
            if (isMatrixCompleted) {
                this.isInputFocused = false;
                this.$emit('processReply');
            } else if (this.$refs.input) {
                this.$refs.input[index].$el.focus();
            }
        },
    },
    computed: {
        currentClassForTextInCell() {
            return this.tableSize.amountOfColumns === 5 ? 'matrix-link__text-container__value_phrase-small' : 'matrix-link__text-container__value_phrase-big'
        }
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.calculateSizeForMatrixTable);
    },
    components: {
        Drop,
        Drag
    }
}
</script>

<style scoped lang="scss">
.link {
  display: inline-flex;
}

.link-icon {
  width: 50px;
}

.link-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.drop-zone {
  display: inline-flex;
  width: 100%;
  height: 100%;
}

.drop-zone__shake-zone {
  width: 100%;
  height: 100%;
  margin: auto;
  background: white;
  border-radius: $border-radius-12;
}

.matrix-container {
  height: 100%;
  background-color: white;
  border: 1px solid $hsl-color-gray-97;
  border-left: none;
  border-right: none;
  padding: 20px 40px;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
  user-select: none;
  min-height: 255px;
  text-align: center;
}

.matrix-container {
  background-color: transparent;
  border: none;
}

.matrix-container__drag {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.matrix-link {
  display: inline-block;
  vertical-align: middle;
  border-radius: $border-radius-12;
  margin-left: 20px;
  cursor: grab;
  max-height: 200px;
}

.matrix-link__text-container, .matrix-link__input-container {
  width: 100%;
  height: 100%;
  margin: auto;
  background: white;
  border: 3px solid $hsl-color-gray-96;
  border-radius: $border-radius-12;
  text-align: center;
  font-size: 28px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    outline: none;
  }
  word-break: break-word;
}

.matrix-link__text-container__value {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 10px;
  overflow-wrap: break-word;
  white-space: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}

.matrix-link__text-container__value_phrase-small {
  font-size: 1rem;
}

.matrix-link__text-container__value_phrase-big {
  font-size: 1.2rem;
}

.matrix-link__text-input {
  border-radius: 0;
  text-align: center;
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-wrap: break-word;
  white-space: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 10px 8px !important;
  font-size: 1.5rem !important;
  &::placeholder {
    font-size: 1.2rem !important;
  }
}

.matrix-link {
  margin-left: 0;
}

.matrix-link_correct {
  border: 3px solid $hsl-color-green-58;
}

.matrix-link_tipped {
  border: 3px solid $hsl-color-yellow-66;
}

.matrix-link_in-turn {
  width: 200px;
  height: 200px;
  border: 3px solid $hsl-color-gray-74;
  border-radius: $border-radius-12;
}

.matrix-table {
  width: 92%;
  height: 92%;
  margin: 10px 30px;
  table-layout: fixed;
  @include media($xlg) {
    width: 80%;
    height: 80%;
  }
}

.matrix-table__cell {
  width: 200px;
  height: 200px;
  text-align: center;
  vertical-align: middle;
  background: inherit;
  box-sizing: border-box;
}

.matrix-table__item {
  width: 95%;
  height: 95%;
  margin: auto;
  display: inline-flex;
  cursor: pointer;
  font-size: 38px;
  user-select: none;
  align-items: center;
  border-radius: $border-radius-12;
  justify-content: center;
  background-color: white;
  transition: background-color 0.1s;
  border: 2px solid $hsl-color-gray-96;
}

@import '@/assets/sass/animations/shake.scss';
</style>
